import React from 'react';
import { TradeConfiguration } from '../components/trading/TradeConfiguration';
import { AlgorithmConfigTable } from '../components/trading/AlgorithmConfigTable';
import { AIModelSelector } from '../features/ai-analyst/components/AIModelSelector';
import { EmergencyStopSection } from '../components/risk/EmergencyStopSection';
import { ProfitTargetSection } from '../components/risk/ProfitTargetSection';
import { ModeToggle } from '../components/ModeToggle';

export function Settings() {
  return (
    <div>
      {/* Settings sections */}
      <div className="space-y-8">
        {/* Annie Mode toggle (Phase 8 — PR #152) */}
        <div className="rh-card p-6">
          <h2 className="text-2xl font-medium text-gray-900 dark:text-white mb-4">
            Mode
          </h2>
          <ModeToggle />
        </div>

        {/* Emergency Stop Section - Most important, at top */}
        <div className="rh-card p-6">
          <h2 className="text-2xl font-medium text-gray-900 dark:text-white mb-6">
            Emergency Stop
          </h2>
          <EmergencyStopSection />
        </div>

        {/* Daily Profit Target Section */}
        <div className="rh-card p-6">
          <h2 className="text-2xl font-medium text-gray-900 dark:text-white mb-6">
            Daily Profit Target
          </h2>
          <ProfitTargetSection />
        </div>

        {/* AI Trade Analyst Section */}
        <div className="rh-card p-6">
          <h2 className="text-2xl font-medium text-gray-900 dark:text-white mb-6">
            AI Trade Analyst
          </h2>
          <AIModelSelector />
        </div>

        {/* Webhook Trading Setup Section */}
        <div className="rh-card p-6">
          <h2 className="text-2xl font-medium text-gray-900 dark:text-white mb-6">
            Webhook Trading Setup
          </h2>
          <TradeConfiguration />
        </div>

        {/* Webhook Configurations Section */}
        <div className="rh-card p-6">
          <h2 className="text-2xl font-medium text-gray-900 dark:text-white mb-6">
            Webhook Configurations
          </h2>
          <AlgorithmConfigTable />
        </div>
      </div>
    </div>
  );
}
